var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPitchetmp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pitchetmp",
    transform: "translate(-21.001 -244.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Icon",
    "data-name": "Dashboard/Icon",
    transform: "translate(-484.988 -81.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1897",
    "data-name": "Group 1897",
    transform: "translate(510.964 333.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2031",
    "data-name": "Group 2031",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M16.212,28.128v3.145h-1.8a.532.532,0,0,0-.518.518v.346a.532.532,0,0,0,.518.518h6.222a.532.532,0,0,0,.518-.518v-.346a.532.532,0,0,0-.518-.518H18.943V28.128Z",
    transform: "translate(-7.502 -14.941)",
    fill: "none",
    stroke: "#2c728a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    d: "M1.448,0H18.6a1.449,1.449,0,0,1,1.449,1.449V11.738A1.449,1.449,0,0,1,18.6,13.187H1.448A1.448,1.448,0,0,1,0,11.739V1.448A1.448,1.448,0,0,1,1.448,0Z",
    fill: "none",
    stroke: "#2c728a",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346",
    "data-name": "Line 346",
    x2: 5.702,
    y2: 0.011,
    transform: "translate(10.801 6.568)",
    fill: "none",
    stroke: "#256f92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_443",
    "data-name": "Line 443",
    x2: 5.702,
    y2: 0.011,
    transform: "translate(2.801 6.568)",
    fill: "none",
    stroke: "#256f92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347",
    "data-name": "Line 347",
    x2: 3.477,
    y2: 0.011,
    transform: "translate(10.801 9.656)",
    fill: "none",
    stroke: "#256f92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_444",
    "data-name": "Line 444",
    x2: 3.477,
    y2: 0.011,
    transform: "translate(2.801 9.099)",
    fill: "none",
    stroke: "#256f92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348",
    "data-name": "Line 348",
    x2: 3.477,
    y2: 0.011,
    transform: "translate(10.801 3.481)",
    fill: "none",
    stroke: "#256f92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_442",
    "data-name": "Line 442",
    x2: 3.477,
    y2: 0.011,
    transform: "translate(2.801 4.076)",
    fill: "none",
    stroke: "#256f92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1501",
    "data-name": "Rectangle 1501",
    width: 30,
    height: 30,
    transform: "translate(505.988 326.744)",
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchetmp);
export default __webpack_public_path__ + "static/media/Pitchetmp.e5a8a2f682fe377b12fe4a1ee3978af0.svg";
export { ForwardRef as ReactComponent };